import { render, staticRenderFns } from "./TemplateTags.vue?vue&type=template&id=01a9c73c&"
import script from "./TemplateTags.vue?vue&type=script&lang=ts&"
export * from "./TemplateTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports